import toast from "react-hot-toast";
import { authenthicate } from "./helper";
import { isAfter, isBefore, isValid, parse, toDate } from "date-fns";
import { isValidUrl } from "../components/proto/helperFunctions/helpers";

/** validate login page username */
export async function usernameValidate(values) {
  const errors = usernameVerify({}, values);

  if (values.username) {
    // check user exist or not
    const { status } = await authenthicate(values.username);

    if (status !== 200) {
      errors.exist = toast.error("User does not exist");
    }
  }
  return errors;
}

/** password validate */
export async function passwordValidate(values) {
  const errors = passwordVerify({}, values);
  return errors;
}

/** validate reset password */
export async function resetPasswordValidation(values) {
  const errors = passwordVerify({}, values);

  if (values.password !== values.confirm_pwd) {
    errors.exists = toast.error("Password not match...!");
  }

  return errors;
}

/** validate register form */
export async function registerValidation(values) {
  const errors = usernameVerify({}, values);
  passwordVerify(errors, values);
  emailVerify(errors, values);

  return errors;
}

/** validate profile page */
export async function profileValidation(values) {
  const errors = emailVerify({}, values);
  return errors;
}

/**** *** */

function passwordVerify(errors = {}, values) {
  const specialChars = /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;

  if (!values.password) {
    errors.password = toast.error("Password Required...!");
  } else if (values.password.includes(" ")) {
    errors.password = toast.error("Wrong Password...!");
  } else if (values.password.length < 4) {
    errors.password = toast.error(
      "Password must be more than 4 letters long...!",
    );
  } else if (!specialChars.test(values.password)) {
    errors.password = toast.error("Password must have special characters...!");
  }
}

/**  */

/** validate username */
function usernameVerify(error = {}, values) {
  if (!values.username) {
    error.username = toast.error("Username Required...!");
  } else if (values.username.includes(" ")) {
    error.username = toast.error("Invalid Username...!");
  }

  return error;
}

/** validate email */
function emailVerify(error = {}, values) {
  if (!values.email) {
    error.email = toast.error("Email Required...!");
  } else if (values.email.includes(" ")) {
    error.email = toast.error("Wrong Email...!");
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    error.email = toast.error("Invalid email address...!");
  }

  return error;
}

/**
 * PAGONI
 * */
/** validate password */
function normalPasswordVerify(error = {}, values) {
  if (!values.password) {
    error.password = toast.error("Password Required...!");
  } else if (values.username.includes(" ")) {
    error.password = toast.error("Password Username...!");
  }

  return error;
}
/* validate login page username */
export async function usernamePasswordValidate(values) {
  const errors = usernameVerify({}, values);
  normalPasswordVerify(errors, values);

  /*if (values.username) {
    // check user exist or not
    const { status } = await authenthicate(values.username);

    if (status !== 200) {
      errors.exist = toast.error("User does not exist");
    }
  }*/
  return errors;
}

/**
 * Login
 */

/** validate username */
function username2Verify(error = {}, values) {
  const MinimumLength = 5;
  if (!values.username) {
    error.username = "Nombre de usuario requerido";
  } else if (values.username.includes(" ")) {
    error.username = "Nombre de usuario no debe contener espacios...!";
  } else if (values.username.length < MinimumLength) {
    error.username = `Nombre de usuario tamaño mínimo es de ${MinimumLength} caracteres...!`;
  }
  return error;
}

function password2Verify(error = {}, values) {
  /*
  https://stackoverflow.com/questions/26322867/how-to-validate-password-using-following-conditions
  */
  const MinimumLength = 5;
  if (!values.password) {
    error.password = "Password requerido";
  } else if (values.password.includes(" ")) {
    error.password = "Password no debe contener espacios...!";
  } /*else if (
    !(
      (
        /[A-Z]/.test(values.password) &&
        /[a-z]/.test(values.password) &&
        /[0-9]/.test(values.password)
      )
      // special chars && /[^A-Za-z0-9]/.test(values.password)
    )
  ) {
    error.password = `Password debe contener al menos 1 mayuscula, 1 minuscula y 1 numero...!`;
  } */ else if (values.password.length < MinimumLength) {
    error.password = `Password tamaño mínimo es de ${MinimumLength} caracteres...!`;
  }

  return error;
}

/* validate login page username */
export async function usernamePasswordLoginValidate(values) {
  const errors = username2Verify({}, values);
  password2Verify(errors, values);

  return errors;
}

/* validate reset username */
export async function resetUsernameValidate(values) {
  const errors = username2Verify({}, values);

  return errors;
}

//
function confirmPassword2Verify(error = {}, values) {
  if (values.password !== values.confirmPassword) {
    error.confirmPassword = "Passwords no concuerdan...!";
  }

  return error;
}
//

/* validate NuevoPassword username */
export async function newPasswordConfirmValidate(values) {
  const errors = password2Verify({}, values);

  confirmPassword2Verify(errors, values);

  return errors;
}
/**
 * CreateUser
 */
/* validate login page username */
export async function userFormValidate(values) {
  const errors = nameVerify({}, values);
  userNameVerify(errors, values);
  apellidoPaternoVerify(errors, values);
  email2Verify(errors, values);
  dateMinimumValidator(errors, values);

  selectCiudadVerify(errors, values);
  selectDepartamentoVerify(errors, values);
  selectRolVerify(errors, values);
  selectNivelUsuarioVerify(errors, values);

  return errors;
}

export async function formValidate(values) {
  const errors = mensajeVerify({}, values);

  return errors;
}

/**
 * CreateUser
 */
/* validate login page username */
export async function editUserFormValidate(values) {
  let errors = nameVerify({}, values);
  //nickNameVerify(errors, values);

  //  dateMinimumValidator(errors, values);

  //const emailErrors = email2Verify({}, values);
  //  const celularErrors = celularVerify({}, values);

  //  const emailErrorCount = Object.keys(emailErrors).length > 0;
  //  const celularErrorCount = Object.keys(celularErrors).length > 0;

  /*if (
    (emailErrorCount ^ celularErrorCount) === 0 ||
    (emailErrorCount && celularErrorCount) === 0
  ) {
    errors = { ...errors, ...emailErrors, ...celularErrors };
  }*/
  //dateValidator(errors, values);
  //curpVerify(errors, values);
  asociadosIdVerify(errors, values);

  return errors;
}

export async function createUserFormValidate(values) {
  let errors = nameVerify({}, values);
  //nickNameVerify(errors, values);

  //  dateMinimumValidator(errors, values);

  apellidoPaternoVerify(errors, values);

  celularVerify(errors, values);

  asociadosIdVerify(errors, values);

  return errors;
}

function celularVerify(error = {}, values) {
  const CELLUAR_CHARS_LENGTH = 10;
  const phone = values.celular.replace(/\D/g, "");
  if (!values.celular) {
    error.celular = "Numero celular requerido...!";
  } else if (phone.includes(" ")) {
    error.celular = "Numero celular invalido...!";
  } /* else if (Number.isNaN(phone)) {
    error.numAsociado = "Numero celular debe contener solo numeros...!";
  }*/ else if (phone.length !== 10) {
    error.celular = `Numero celular debe tener ${CELLUAR_CHARS_LENGTH} numeros...!`;
  }

  return error;
}

function asociadoIdVerify(error = {}, values) {
  if (!values.asociadoId) {
    error.asociadoId = "Asociado requerido...!";
  }
  const number = parseInt(values.asociadoId);
  if (!number || Number.isNaN(number)) {
    error.asociadoId = "Asociado invalido...!";
  } else if (number < 0) {
    error.asociadoId = "Asociado invalido...!";
  }
}

function asociadosIdVerify(error = {}, values) {
  if (!values.asociadosIds || values.asociadosIds.length === 0) {
    error.asociadoId = "Al menos 1 asociado es requerido...!";
    return;
  }

  /*  values.asociadosIds.forEach((asociadoId) => {
    const number = Number.parseInt(asociadoId);
    if (!number || Number.isNaN(number) || number < 0) {
      error.asociadoId = "Asociado invalido...!";
    }
  });*/
}

function formaDePagoIdVerify(error = {}, values) {
  if (!values.formaDePagoId) {
    error.formaDePagoId = "Forma de Pago requerido...!";
  }
  const number = Number.parseInt(values.formaDePagoId);
  if (!number || Number.isNaN(number) || number < 0) {
    error.formaDePagoId = "Forma de Pago invalido...!";
  }
}

function metodoDePagoIdVerify(error = {}, values) {
  if (!values.metodoDePagoId) {
    error.metodoDePagoId = "Metodo de Pago requerido...!";
  }
  const number = Number.parseInt(values.metodoDePagoId);
  if (!number || Number.isNaN(number) || number < 0) {
    error.metodoDePagoId = "Metodo de Pago invalido...!";
  }
}

/**
 * Create CatalogoItems
 */
export async function createCatalogoItemFormShortValidate(values) {
  let errors = nombreCortoVerify({}, values);

  return errors;
}

export async function createCatalogoItemFormValidate(values) {
  let errors = nombreCortoVerify({}, values);

  nombre2Verify(errors, values);
  //  numVerify(errors, values);

  return errors;
}

function nombre2Verify(error = {}, values) {
  if (!values.nombre) {
    error.nombre = "Nombre requerido...!";
  } else if (values.nombre.includes(" ")) {
    error.nombre = "Nombre invalido...!";
  } else if (values.nombre.length < 1) {
    error.nombre = "Nombre no debe ser vacio..!";
  }

  return error;
}

function nombre2Verify2(error = {}, values) {
  if (!values.nombre) {
    error.nombre = "Nombre requerido...!";
  } else if (values.nombre.trim().length === 0) {
    error.nombre = "Nombre no debe ser vacio..!";
  }

  return error;
}

function nombreCortoVerify(error = {}, values) {
  if (!values.nombreCorto) {
    error.nombreCorto = "Nombre Corto requerido...!";
  } else if (values.nombreCorto.includes(" ")) {
    error.nombreCorto = "Nombre Corto invalido...!";
  } else if (values.nombreCorto.length < 1) {
    error.nombreCorto = "Nombre Corto no debe ser vacio...!";
  }

  return error;
}

function numVerify(error = {}, values) {
  if (!values.num) {
    error.num = "Numero requerido...!";
  } else if (values.num.includes(" ")) {
    error.num = "Numero invalido...!";
  } else if (Number.isNaN(values.num)) {
    error.num = "Numero debe contener solo numeros...!";
  } else if (values.num.length < 1) {
    error.num = "Numero debe tener 1 caracteres mínimo...!";
  }

  return error;
}

function dateValidator(error = {}, values) {
  if (!values.fechaNacimiento) {
    error.fechaNacimiento = "Fecha de nacimiento requerido...!";
  } else {
    try {
      //const aDate = format(values.fechaNacimiento, "yyyy-MM-dd");
      const aDate = parse(values.fechaNacimiento, "yyyy-MM-dd", new Date());
      if (!isValid(aDate)) {
        error.fechaNacimiento = "Fecha de nacimiento invalida...!";
      }
    } catch (e) {
      console.log("--> dateValidator: " + e);
    }
  }

  return error;
}

function dateMinimumValidator(error = {}, values) {
  if (!values.fechaNacimiento) {
    error.fechaNacimiento = "Fecha de nacimiento requerido...!";
  } else {
    try {
      const aDate = parse(values.fechaNacimiento, "yyyy-MM-dd", new Date());
      //let re = isValid(one);
      //  const aDate = format(values.fechaNacimiento, "yyyy-MM-dd");
      if (!isValid(aDate)) {
        error.fechaNacimiento = "Fecha de nacimiento invalida...!";
      } else if (isBefore(aDate, new Date(1900, 0, 1))) {
        error.fechaNacimiento =
          "Fecha de nacimiento año mínimo debe ser 1900...!";
      }
    } catch (e) {
      console.log("--> dateValidator: " + e);
    }
  }

  return error;
}

function nameVerify(error = {}, values) {
  if (!values.nombre) {
    error.nombre = "Nombre requerido...!";
  } /* else if (values.name.includes(" ")) {
    error.name = "Nombre invalido...!";
  } 
  */ else if (values.nombre.length < 3) {
    error.nombre = "Nombre debe tener 3 caracteres mínimo...!";
  }

  return error;
}

function mensajeVerify(error = {}, values) {
  if (!values.mensaje) {
    error.mensaje = "Nombre requerido...!";
  } /* else if (values.name.includes(" ")) {
    error.name = "Nombre invalido...!";
  } 
  */ else if (values.mensaje.length < 3) {
    error.nombre = "Mensaje debe tener 3 caracteres mínimo...!";
  }

  return error;
}

function curpVerify(error = {}, values) {
  // https://www.gob.mx/segob%7Crenapo/articulos/sabes-como-se-conforma-tu-curp?idiom=es#:~:text=La%20CURP%20se%20integra%20por,A%20continuación%20conocerás%20su%20composición&text=Nuevo%20Formato%20de%20la%20CURP.
  const CURP_CHARS_LENGTH = 18;
  if (values.curp.length === 0) {
    error.curp = "CURP requerido...!";
  } else if (values.curp.includes(" ")) {
    error.curp = "CURP invalido...!";
  } else if (values.curp.length !== CURP_CHARS_LENGTH) {
    error.curp = `El CURP debe contener ${CURP_CHARS_LENGTH} caracteres...!`;
  }

  return error;
}

function urlDocumentacionVerify(error = {}, values) {
  if (values.rutaDocumentacion.length === 0) return error;
  if (!isValidUrl(values.rutaDocumentacion)) {
    error.rutaDocumentacion = "URL invalido...!";
  }

  return error;
}

function userNameVerify(error = {}, values) {
  if (!values.username) {
    error.username = "Usuario requerido...!";
  } else if (values.username.includes(" ")) {
    error.username = "Usuario invalido...!";
  } else if (values.username.length < 3) {
    error.username = "Usuario debe tener 5 caracteres mínimo...!";
  }

  return error;
}

function apellidoPaternoVerify(error = {}, values) {
  if (!values.apellidoPaterno) {
    error.apellidoPaterno = "Apellido requerido...!";
  } else if (values.apellidoPaterno.length < 3) {
    error.apellidoPaterno = "Apellido debe tener 3 caracteres mínimo...!";
  }

  return error;
}

function nickNameVerify(error = {}, values) {
  if (!values.nickname) {
    error.nickname = "Nickname requerido...!";
  } else if (values.nickname.includes(" ")) {
    error.nickname = "Nickname invalido...!";
  } else if (values.nickname.length < 3) {
    error.nickname = "Nickname debe tener 5 caracteres mínimo...!";
  }

  return error;
}

/** validate email */
function email2Verify(error = {}, values) {
  if (!values.correo) {
    error.correo = "Email requerido...!";
  } else if (values.correo.includes(" ")) {
    error.correo = "Email incorrecto...!";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.correo)) {
    error.correo = "Email invalido...!";
  }

  return error;
}

/**
 * CreateAsociado
 */
/* validate login page username */
export async function createAsociadoFormValidate(values) {
  //const errors = numeroAsociadoVerify({}, values);
  let errors = nameVerify({}, values);
  dateValidator(errors, values);
  curpVerify(errors, values);

  urlDocumentacionVerify(errors, values);

  const emailErrors = email2Verify({}, values);
  const celularErrors = celularVerify({}, values);

  const emailErrorCount = Object.keys(emailErrors).length > 0;
  const celularErrorCount = Object.keys(celularErrors).length > 0;

  if (
    (emailErrorCount ^ celularErrorCount) === 0 ||
    (emailErrorCount && celularErrorCount) === 0
  ) {
    errors = { ...errors, ...emailErrors, ...celularErrors };
  }

  return errors;
}

/**
 * CreateBanco
 */
/* validate login page username */
export async function createBancoFormValidate(values) {
  const errors = nameVerify({}, values);
  aliasVerify(errors, values);
  cuentaVerify(errors, values);

  return errors;
}

function aliasVerify(error = {}, values) {
  if (!values.alias) {
    error.alias = "Alias requerido...!";
  } else if (values.name.includes(" ")) {
    error.name = "Alias invalido...!";
  } else if (values.alias.length < 3) {
    error.alias = "Alias debe tener 3 caracteres mínimo...!";
  }

  return error;
}

function cuentaVerify(error = {}, values) {
  if (!values.cuenta) {
    error.cuenta = "Cuenta requerida...!";
  } else if (values.name.includes(" ")) {
    error.name = "Cuenta invalido...!";
  } else if (values.cuenta.length < 3) {
    error.cuenta = "Cuenta debe tener 3 caracteres mínimo...!";
  }

  return error;
}

/**
 * CreateDireccion
 */
/* validate login page username */
export async function createDireccionFormValidate(values) {
  const errors = nameVerify({}, values);

  return errors;
}

/**
 *
 */
function numeroAsociadoVerify(error = {}, values) {
  if (!values.numAsociado) {
    error.numAsociado = "Numero asociado requerido...!";
  } else if (values.numAsociado.includes(" ")) {
    error.numAsociado = "Numero asociado invalido...!";
  } else if (Number.isNaN(values.numAsociado)) {
    error.numAsociado = "Numero asociado debe contener solo numeros...!";
  } else if (values.numAsociado.length < 1) {
    error.numAsociado = "Numero asociado debe tener 1 caracteres mínimo...!";
  }

  return error;
}

function selectCiudadVerify(error = {}, values) {
  if (values.ciudadId > 0) {
    return error;
  }

  error.ciudadId = "Ciudad requerida...!";

  return error;
}

function selectDepartamentoVerify(error = {}, values) {
  if (values.departamentoId > 0) {
    return error;
  }

  error.departamentoId = "Departamento requerida...!";

  return error;
}

function selectNivelUsuarioVerify(error = {}, values) {
  if (values.nivelUsuarioId > 0) {
    return error;
  }

  error.nivelUsuarioId = "Nivel Usuario requerido...!";

  return error;
}

function selectRolVerify(error = {}, values) {
  if (values.rolId > 0) {
    return error;
  }

  error.rolId = "Rol requerido...!";

  return error;
}

/**
 * CreateAsociado
 */
/* validate login page username */
export async function scheduleHoursFormValidate(values) {
  const errors = {};

  const horaInicial = hourValuesVerify(values.horaInicial);
  const horaFinal = hourValuesVerify(values.horaFinal);

  if (horaInicial) {
    errors.horaInicial = horaInicial;
  }

  if (horaInicial) {
    errors.horaFinal = horaFinal;
  }

  if (
    isAfter(
      toDate("2025-01-01T" + values.horaInicial),
      toDate("2025-01-01T" + values.horaFinal),
    )
  ) {
    errors.horaInicial = "Hora Inicial no debe ser mayor que Hora Final...!";
  }
  /*else if(isBefore(values.horaInicial, values.)){
    errors.horaFinal = "Hora Final no debe ser menor que Hora Inicial...!"
  }*/

  return errors;
}

function hourValuesVerify(scheduleTime) {
  let errorInfo = null;
  if (!scheduleTime) {
    errorInfo = "Hora requerida...!";
  } else if (scheduleTime.includes(" ")) {
    errorInfo = "Hora incorrecta...!";
  } else if (
    !/^([01][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/i.test(scheduleTime)
  ) {
    errorInfo = "Hora invalida...!";
  }

  return errorInfo;
}

/**
 * CreateProducto
 */
/* validate login page username */
export async function productoFormValidate(values) {
  const errors = productoNameVerify({}, values);
  //  precioCostoVerify(errors, values);
  //  precioVentaVerify(errors, values);
  //SKUVerify(errors, values);
  codigoBarrasVerify(errors, values);

  marcaIdVerify(errors, values);
  generoIdVerify(errors, values);
  tamanoIdVerify(errors, values);
  concentracionIdVerify(errors, values);
  presentacionIdVerify(errors, values);

  return errors;
}

function productoNameVerify(error = {}, values) {
  if (!values.nombre) {
    error.nombre = "Nombre de producto requerido...!";
  } else if (values.nombre.length < 5) {
    error.nombre = "Nombre de producto debe tener 5 caracteres mínimo...!";
  }

  return error;
}

function precioCostoVerify(error = {}, values) {
  if (!values.precioCosto) {
    error.precioCosto = "Precio Costo requerido...!";
  } else if (Number.isNaN(values.precioCosto)) {
    error.precioCosto = "Precio Venta debe contener solo numeros...!";
  } else if (parseFloat(values.precioCosto) <= 0) {
    error.precioCosto = "Precio Costo debe ser mayor a 0";
  }

  return error;
}

function precioVentaVerify(error = {}, values) {
  if (!values.precioVenta) {
    error.precioVenta = "Precio Venta requerido...!";
  } else if (Number.isNaN(values.precioVenta)) {
    error.precioVenta = "Precio Venta debe contener solo numeros...!";
  } else if (parseFloat(values.precioVenta) <= 0) {
    error.precioVenta = "Precio Venta debe ser mayor a 0";
  }

  return error;
}

function SKUVerify(error = {}, values) {
  if (!values.numProducto) {
    error.numProducto = "SKU requerido...!";
  } else if (values.numProducto.includes(" ")) {
    error.numProducto = "SKU invalido...!";
  } else if (values.numProducto.length < 5) {
    error.numProducto = "SKU debe tener 5 caracteres mínimo...!";
  }

  return error;
}

function codigoBarrasVerify(error = {}, values) {
  if (!values.codigoBarras) {
    error.codigoBarras = "Código de barras requerido...!";
  } else if (values.codigoBarras.includes(" ")) {
    error.codigoBarras = "Código de barras invalido...!";
  } else if (values.codigoBarras.length < 6) {
    error.codigoBarras = "Código de barras debe tener 6 caracteres mínimo...!";
  }

  return error;
}

function marcaIdVerify(error = {}, values) {
  if (values.marcaId > 0) {
    return error;
  }
  error.marcaId = "Marca requerida...!";
  return error;
}

function generoIdVerify(error = {}, values) {
  if (values.generoId > 0) {
    return error;
  }
  error.generoId = "Genero requerido...!";
  return error;
}

function tamanoIdVerify(error = {}, values) {
  if (values.tamañoId > 0) {
    return error;
  }
  error.tamañoId = "Tamaño requerido...!";
  return error;
}

function concentracionIdVerify(error = {}, values) {
  if (values.concentracionId > 0) {
    return error;
  }
  error.concentracionId = "Concentración requerido...!";
  return error;
}

function presentacionIdVerify(error = {}, values) {
  if (values.presentacionId > 0) {
    return error;
  }
  error.presentacionId = "Presentación requerido...!";
  return error;
}

/**
 * CreateProducto
 */
/* validate login page username */
export async function proveedorFormValidate(values) {
  const errors = proveedorNameVerify({}, values);

  return errors;
}

export async function pedidoEspecialFormValidate(values) {
  const errors = proveedorNameVerify({}, values);

  cantidadVerify(errors, values);
  precioCostoVerify(errors, values);
  precioPublicoVerify(errors, values);
  margenVerify(errors, values);
  //marcaIdVerify(errors, values);

  marcaIdVerify(errors, values);
  ordenDateValidator(errors, values);
  proveedorIdVerify(errors, values);
  generoIdVerify(errors, values);
  categoriaCompraIdVerify(errors, values);

  return errors;
}

function precioPublicoVerify(error = {}, values) {
  if (!values.precioPublico) {
    error.precioPublico = "Precio Publico requerido...!";
  } else if (Number.isNaN(values.precioPublico)) {
    error.precioPublico = "Precio Publico debe contener solo numeros...!";
  } else if (parseFloat(values.precioPublico) <= 0) {
    error.precioPublico = "Precio Publico debe ser mayor a 0";
  }

  return error;
}

function margenVerify(error = {}, values) {
  if (!values.margen) {
    error.margen = "Margen requerido...!";
  } else if (Number.isNaN(values.margen)) {
    error.margen = "Margen debe contener solo numeros...!";
  } else if (parseFloat(values.margen) <= 0) {
    error.margen = "Margen debe ser mayor a 0";
  }

  return error;
}

function cantidadVerify(error = {}, values) {
  if (!values.cantidad) {
    error.cantidad = "Cantidad requerida...!";
  } else if (Number.isNaN(values.precioCosto)) {
    error.cantidad = "Cantidad debe contener solo numeros...!";
  } else if (parseFloat(values.precioCosto) <= 0) {
    error.cantidad = "Cantidad debe ser mayor a 0";
  }

  return error;
}

function categoriaCompraIdVerify(error = {}, values) {
  if (values.categoriaCompraId > 0) {
    return error;
  }
  error.categoriaCompraId = "Categoria requerida...!";
  return error;
}

function proveedorIdVerify(error = {}, values) {
  if (values.proveedorId > 0) {
    return error;
  }
  error.proveedorId = "Proveedor requerido...!";
  return error;
}

function proveedorNameVerify(error = {}, values) {
  if (!values.nombre) {
    error.nombre = "Nombre de proveedor requerido...!";
  } else if (values.nombre.length < 5) {
    error.nombre = "Nombre de proveedor debe tener 5 caracteres mínimo...!";
  }

  return error;
}

function ordenDateValidator(error = {}, values) {
  if (!values.fechaOrden) {
    error.fechaOrden = "Fecha de orden requerido...!";
  }

  return error;
}

/**
 * CreateOrden
 */
/* validate login page username */
export async function createOrdenFormValidation(values) {
  const errors = clienteIdVerify({}, values);

  asociadoIdVerify(errors, values);

  metodoDePagoIdVerify(errors, values);
  formaDePagoIdVerify(errors, values);

  ordenVentaVerify(errors, values);

  return errors;
}

function clienteIdVerify(error = {}, values) {
  if (values.clienteId > 0) {
    return error;
  }
  //  error.clienteId = "Cliente requerido...!";
  return error;
}

function ordenVentaVerify(error = {}, values) {
  if (values.ordenVentaDetalles.length > 0) {
    return error;
  }
  error.ordenVentaDetalles = "Debe contener al menos 1 producto...!";
  return error;
}

/**
 * CreateOrden
 */
/* validate login page username */
export async function configForaneoFormValidation(values) {
  const errors = paqueteriaVerify({}, values);

  guiaVerify(errors, values);

  dateFechaEntregaMinimumValidator(errors, values);

  return errors;
}

function paqueteriaVerify(error = {}, values) {
  if (!values.paqueteria) {
    error.paqueteria = "Paqueteria requerida...!";
  } else if (values.paqueteria.length < 3) {
    error.paqueteria = "Paqueteria debe tener 3 caracteres mínimo...!";
  }

  return error;
}

function guiaVerify(error = {}, values) {
  if (!values.guia) {
    error.guia = "Guia requerido...!";
  } else if (values.guia.length < 5) {
    error.guia = "Guia debe tener 5 caracteres mínimo...!";
  }

  return error;
}

function dateFechaEntregaMinimumValidator(error = {}, values) {
  if (!values.fechaEntrega) {
    error.fechaEntrega = "Fecha de entrega requerido...!";
  } else {
    try {
      const aDate = parse(values.fechaEntrega, "yyyy-MM-dd", new Date());
      //let re = isValid(one);
      //  const aDate = format(values.fechaEntrega, "yyyy-MM-dd");
      if (!isValid(aDate)) {
        error.fechaEntrega = "Fecha de entrega invalida...!";
      } else if (isBefore(aDate, new Date(1900, 0, 1))) {
        error.fechaEntrega = "Fecha de entrega año mínimo debe ser 1900...!";
      }
    } catch (e) {
      console.log("--> dateValidator: " + e);
    }
  }

  return error;
}

/**
 * CreatePAquete
 */
export async function createPaqueteFormValidation(values) {
  const errors = paquetesVerify({}, values);

  nombre2Verify2(errors, values);

  return errors;
}

function paquetesVerify(error = {}, values) {
  if (values.productos.length > 0) {
    return error;
  }
  error.productos = "Debe contener al menos 1 producto...!";
  return error;
}

/**
 * CreateOrden
 */
/* validate login page username */
export async function selectBonificacionFormValidation(values) {
  const errors = promocionIdVerify({}, values);

  return errors;
}

function promocionIdVerify(error = {}, values) {
  if (values.promocionId > 0) {
    return error;
  }
  error.promocionId = "Selecciona una promoción...!";
  return error;
}
